import { ReactNode } from 'react';

import styles from './group.module.scss';

export function OneColumnGroup({
  children,
  slim,
}: {
  children: ReactNode;
  slim?: boolean;
}) {
  return (
    <div
      className={`page-content__column--one ${styles['one-column']} ${slim ? styles['one-column--slim'] : ''}`}
    >
      {children}
    </div>
  );
}
